import React from "react";
import styles from "./WizardContent.module.scss";
import layoutStyles from "./../Layout/Layout.module.scss"
import {ArrowLeftIcon as PreviousArrow} from "@netapp/bxp-style/react-icons/Navigation";
import classNames from "classnames";

const WizardContent = ({children, onPreviousStep, className, style}) => {
    return <div className={classNames(layoutStyles['wizard-content'], className)} style={style}>
        {onPreviousStep && <button type="button" className={styles["previous-step"]} onClick={onPreviousStep}><PreviousArrow/>Previous Step</button>}
        {children}
    </div>
}

export default WizardContent;
